import { ComponentProps } from "../registry";
import { useBound } from "../helpers";
import { BoundValue } from "../../types";

interface Step { label: string }

export function Stepper({ fields, scope }: ComponentProps) {
  const steps = useBound<Step[]>(fields.steps as BoundValue, scope) ?? [];
  const current = useBound<number>(fields.currentStep as BoundValue, scope) ?? 0;

  return (
    <div className="a2-stepper">
      {steps.map((s, i) => (
        <div
          key={i}
          className={`a2-step ${i < current ? "done" : i === current ? "current" : "pending"}`}
        >
          <div className="a2-step-circle">{i < current ? "✓" : i + 1}</div>
          <div className="a2-step-label">{s.label}</div>
        </div>
      ))}
    </div>
  );
}
